module.exports = __webpack_public_path__ + "static/media/logo.4d18b3ae.svg";